// Authentication service for handling sign-in and sign-up functionality
import { UserData, LoginCredentials, SignUpData, AuthResponse, ResetPass, ForgotPasswordData, ResetPassResponse } from '../types/auth.types';
import { API_CONFIG } from "../utils/constants";
import axios from 'axios';
// Mock authentication functions - in a real app, these would make API calls

const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    // Ensure headers object exists
    config.headers = config.headers || {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        const { data } = await apiClient.post<AuthResponse>(API_CONFIG.ENDPOINTS.REFRESH_TOKEN, {
          refreshToken,
        });
        localStorage.setItem("accessToken", data.access_token);
        localStorage.setItem("refreshToken", data.refresh_token || "");
        return apiClient(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    try {
      const { data } = await apiClient.post<AuthResponse>(API_CONFIG.ENDPOINTS.LOGIN, credentials);
      return data;
    } catch (error: any) {
      throw error;
    }
  },
  signUp: async (payload: SignUpData): Promise<UserData> => {
    try {
      const { data } = await apiClient.post<UserData>(API_CONFIG.ENDPOINTS.REGISTER, payload);
      return data;
    } catch (error: any) {
      throw error;
    }
  },
  logout: async (): Promise<void> => {
    try {
      await apiClient.post(API_CONFIG.ENDPOINTS.LOGOUT);
    } catch (error: any) {
      console.error("Logout API failed:", error);
    }
  },
  forgotPassword: async (credentials: ForgotPasswordData): Promise<any> => {
    try {
      return await apiClient.post<any>(API_CONFIG.ENDPOINTS.FORGOT_PASSWORD, credentials);

    } catch (error: any) {
      throw error;
    }
  },
  resetPassword: async (credentials: ResetPass): Promise<any> => {
    try {
      return await apiClient.post<any>(API_CONFIG.ENDPOINTS.RESET_PASSWORD, credentials);
    } catch (error: any) {
      throw error;
    }
  },
};